import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Moment from 'vue-moment';
// import VueApexCharts from 'vue-apexcharts';
import Cookies from 'js-cookie';
import Vuex from 'vuex';
import CKEditor from 'ckeditor4-vue';

// import './registerServiceWorker'
import {
  MdApp,
  MdRipple,
  MdButton,
  MdDatepicker,
  MdProgress,
  MdCheckbox,
  MdRadio,
  MdSteppers,
  MdIcon,
  MdList,
  MdToolbar,
  MdTooltip,
  MdDrawer,
  MdContent,
  MdCard,
  MdDialog,
  MdDialogAlert,
  MdField,
  MdDivider,
  MdMenu,
  MdSwitch,
  MdChips,
  MdAutocomplete,
  MdTabs,
  MdBottomBar,
  MdBadge,
  MdDialogConfirm,
} from 'vue-material/dist/components';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import '@/assets/scss/_import.scss';
import { createProvider } from './vue-apollo';
import VTooltip from 'v-tooltip';

Vue.config.productionTip = false;

Vue.use(router);
Vue.use(Moment);
Vue.use(Vuex);
Vue.use(VTooltip);
Vue.use(CKEditor);

Vue.component('router-link', Vue.options.components.RouterLink);
Vue.component('router-view', Vue.options.components.RouterView);

// Vue.use(VueApexCharts);
// Vue.component('apexchart', VueApexCharts);

Vue.use(MdProgress);
Vue.use(MdApp);
Vue.use(MdBadge);
Vue.use(MdAutocomplete);
Vue.use(MdSteppers);
Vue.use(MdButton);
Vue.use(MdList);
Vue.use(MdIcon);
Vue.use(MdToolbar);
Vue.use(MdDrawer);
Vue.use(MdContent);
Vue.use(MdCard);
Vue.use(MdDialog);
Vue.use(MdDialogAlert);
Vue.use(MdDialogConfirm);
Vue.use(MdField);
Vue.use(MdMenu);
Vue.use(MdCheckbox);
Vue.use(MdRadio);
Vue.use(MdDivider);
Vue.use(MdTooltip);
Vue.use(MdDatepicker);
Vue.use(MdChips);
Vue.use(MdSwitch);
Vue.use(MdTabs);
Vue.use(MdBottomBar);
Vue.use(MdRipple);

Vue.filter('capitalize', function(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.material.locale.dateFormat = 'dd/MM/yyyy';
let token = Cookies.get('jwt');
if (token && token != '') {
  localStorage.setItem('apollo-token', token);
  Cookies.remove('jwt');
}
const is = (state, role_label) => {
  let roles = [];
  if (state.user && state.user.roles && state.user.roles.length) {
    roles = state.user.roles.filter((role) => {
      return role.label === role_label;
    });
    return roles.length > 0;
  }
  return false;
};
const store = new Vuex.Store({
  state: {
    user: {},
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
  },
  getters: {
    is: (state) => (role_label) => {
      return is(state, role_label);
    },
    isFaculty: (state) => {
      return is(state, 'faculty') || is(state, 'admin');
    },
    isStudent: (state) => {
      return is(state, 'student');
    },
    isGroupLeader: (state) => {
      return is(state, 'admin') || is(state, 'group_leader');
    },
  },
});

new Vue({
  router,
  store: store,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount('#app');
